import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { LoadingDots } from 'foundations-components/transitional/components/LoadingDots';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useAssetCopierContext } from '../providers/AssetCopierProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AwaitingAction() {
  const {
    copyableAssets
  } = useAssetCopierContext();
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    flexDirection: "column",
    "data-test-id": "asset-copier-panel-awaiting-action",
    children: [/*#__PURE__*/_jsx(Illustration, {
      name: "copy-paste",
      height: 150
    }), /*#__PURE__*/_jsx(Text, {
      as: "h4",
      marginBlockStart: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "ui-multi-account-asset-copier.panel.awaitingActionTitle",
        options: {
          count: copyableAssets.length
        }
      })
    }), /*#__PURE__*/_jsx(LoadingDots, {
      minHeight: 50
    })]
  });
}
export default AwaitingAction;